import { render } from "./home_intro.vue?vue&type=template&id=231c2684&scoped=true"
import script from "./home_intro.vue?vue&type=script&lang=js"
export * from "./home_intro.vue?vue&type=script&lang=js"

import "./home_intro.vue?vue&type=style&index=0&id=231c2684&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231c2684"]])

export default __exports__